import React, { useEffect } from 'react';

function DigilockerClosePage() {
  useEffect(() => {
    const closeWindow = () => {
      try {
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage({ type: 'DIGILOCKER_CLOSE' }, window.location.origin);
        }
      } catch (_error) {
        // Ignore opener messaging failures.
      }

      try {
        window.open('', '_self');
        window.close();
      } catch (_error) {
        // Ignore close failures; the page is only a fallback landing screen.
      }
    };

    const timer = window.setTimeout(closeWindow, 0);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#ffffff',
        color: '#0f172a',
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        padding: '24px',
        textAlign: 'center'
      }}
    >
      Closing Aadhaar verification...
    </div>
  );
}

export default DigilockerClosePage;
